import { render } from "./HermesCatalogue.vue?vue&type=template&id=5c3543d4&scoped=true"
import script from "./HermesCatalogue.vue?vue&type=script&lang=js"
export * from "./HermesCatalogue.vue?vue&type=script&lang=js"

import "./HermesCatalogue.vue?vue&type=style&index=0&id=5c3543d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3543d4"]])

export default __exports__